import {  PromiseObservable  } from './PromiseObservable';

export const fromPromise = PromiseObservable.create;


// WEBPACK FOOTER //
// ./node_modules/rxjs/src/observable/fromPromise.ts